/* This example requires Tailwind CSS v2.0+ */
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition
} from '@headlessui/react'
import Link from 'next/link'
import { Fragment } from 'react'

import {
  menuItemLinkClasses,
  menuItemsClasses
} from '~/lib/util/fe/style-guide'

import Icon from '../../ui/Icon'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
interface UserMenuProps {
  firstName: string
  hasBillingRead: boolean
  isAdmin: boolean
  isStriveAdmin: boolean
  needs2FASetup?: boolean
  onLogout: () => any
}

const UserMenu = ({
  hasBillingRead,
  firstName,
  isAdmin,
  isStriveAdmin,
  needs2FASetup = false,
  onLogout
}: UserMenuProps) => {
  const handleLogout = (e) => {
    e.preventDefault
    onLogout()
    return false
  }

  return (
    <Menu
      as="div"
      className="relative inline-block text-left float-right h-[60px]"
      data-testid="headerMenu"
    >
      <div className="h-[60px] items-center">
        <MenuButton
          as="div"
          className="h-full inline-flex justify-center items-center w-full cursor-pointer border-0 px-4 py-0 bg-white text-sm font-medium text-primary hover:bg-bg"
          data-testid="headerMenuAccountName"
        >
          <span className="inline-block px-2 h-full leading-[60px]">
            <Icon
              type="avatar-circle"
              className="text-xl align-middle opacity-40"
            />
          </span>
          <span className="inline-block px-2 pt-[2px] h-full leading-[60px]">
            {firstName}
          </span>
          <span className="mt-[6px] inline-block w-0 h-0 ml-1 border-solid border-4 border-x-transparent border-b-0"></span>
        </MenuButton>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className={menuItemsClasses}>
          {!needs2FASetup && (
            <MenuItem data-testid="headerMenuAccountSettingsLink">
              {({ active }) => (
                <Link
                  href="/account-settings"
                  className={classNames(
                    menuItemLinkClasses,
                    active ? 'bg-primary-300' : undefined,
                    'whitespace-nowrap'
                  )}
                >
                  Account Settings
                </Link>
              )}
            </MenuItem>
          )}
          {!needs2FASetup && isAdmin && (
            <MenuItem data-testid="headerMenuManageUsersLink">
              {({ active }) => (
                <Link
                  href="/manage-users"
                  className={classNames(
                    menuItemLinkClasses,
                    active ? 'bg-primary-300' : undefined
                  )}
                >
                  Manage Users
                </Link>
              )}
            </MenuItem>
          )}
          {!needs2FASetup && isStriveAdmin && (
            <Menu.Item data-testid="headerMenuBillingLink">
              {({ active }) => (
                <Link
                  href="/admin-portal"
                  className={classNames(
                    menuItemLinkClasses,
                    active ? 'bg-primary-300' : undefined,
                    'whitespace-nowrap'
                  )}
                >
                  Strive Admin Portal
                </Link>
              )}
            </Menu.Item>
          )}
          {!needs2FASetup && isAdmin && hasBillingRead && (
            <MenuItem data-testid="headerMenuBillingLink">
              {({ active }) => (
                <Link
                  href="/billing"
                  className={classNames(
                    menuItemLinkClasses,
                    active ? 'bg-primary-300' : undefined,
                    'whitespace-nowrap'
                  )}
                >
                  Billing
                </Link>
              )}
            </MenuItem>
          )}
          <MenuItem data-testid="headerMenuLogOutLink">
            {({ active }) => (
              <Link
                href="/sign-in"
                onClick={handleLogout}
                className={classNames(
                  menuItemLinkClasses,
                  active ? 'bg-primary-300' : undefined
                )}
              >
                Log Out
              </Link>
            )}
          </MenuItem>
        </MenuItems>
      </Transition>
    </Menu>
  )
}

export default UserMenu
